import { useState, useEffect, useRef, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Scheduler, MonthView, SchedulerItem, SchedulerViewSlot, SchedulerViewItem } from "@progress/kendo-react-scheduler";
import EventDateService from "../../services/srv-event/EventDateService";
import LoadingPanel from "../../components/sys-toolbox/LoadingPanel";
import {
  IntlProvider,
  loadMessages,
  LocalizationProvider,
} from "@progress/kendo-react-intl";
import i18n from "../../config/languageInit";
import "../../assets/styles/custom-scheduler.css"
import { useSearchParams } from "react-router-dom";
import { Card, CardBody } from "@progress/kendo-react-layout";

loadMessages(i18n.store.data[i18n.language], i18n.language);

function CompanySchedulerIntra2(props) {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());

  loadMessages(i18n.store.data["tr"], "tr");

  useEffect(() => {
    console.log("useEffect çalıştı...")
    getData();
  }, [searchParams]);

  const validateParameters = (timestamp, signature) => {
    console.log("s1...")
    if (!timestamp || !signature) {
      return false;
    }
    console.log("s2...")

    return true;
  };

  const getData = () => {
    const timestamp = searchParams.get("timestamp");
    const signature = searchParams.get("signature");

    console.log("s3...")
    if (!validateParameters(timestamp, signature)) {
      return;
    }

    console.log("s4...")
    setLoading(true);
    EventDateService.getListIntra(timestamp, signature).then((data) => {
    // EventDateService.getList().then((data) => {
      console.log("s5...")
      console.log(data)
      setLoading(false);
      setData(
        data.map((item) => {
          return {
            id: item.etkinliK_TARIH_ID,
            title: item.etkinliK_ADI,
            start: item.baS_TAR ? new Date(item.baS_TAR) : new Date(),
            end: item.biT_TAR ? new Date(item.biT_TAR) : new Date(),
            color: item.renK_KODU,
          };
        })
      );
    });
  };


  const handlePrevMonth = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() - 1);
    setCurrentDate(newDate);
  };

  const handleNextMonth = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + 1);
    setCurrentDate(newDate);
  };

  const getMonthName = () => {
    const monthNames = [
      "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
      "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
    ];
    return `${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`;
  };

  const CustomViewItem = (props) => {
    return <SchedulerViewItem {...props} style={{
      ...props.style,
      height: 'auto',
      fontSize: "14px",
      fontWeight: "700"
    }} />;
  };

  const CustomItem = (props) => {
    const formatTime = (date) => {
      return date.toLocaleTimeString('tr-TR', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    };
    return (
      <SchedulerItem
        {...props}
        style={{
          ...props.style,
          backgroundColor: props.dataItem.color,
          padding: "4px",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ fontSize: "12px", fontWeight: "600", opacity: 0.9 }}>
          {formatTime(props.dataItem.start)} - {formatTime(props.dataItem.end)}
        </div>
        <div style={{ fontSize: "14px", fontWeight: "700" }}>
          {props.dataItem.title}
        </div>
      </SchedulerItem>
    );
  };

  const CustomViewSlot = (props) => {
    return <SchedulerViewSlot {...props} style={{
      ...props.style,
      minHeight: 120,
      padding: "4px",
      boxSizing: "border-box",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    }} />;
  };

  return (
    <div style={styles.wrapper}>
      <Card style={styles.card}>
        <CardBody style={styles.cardBody}>
          {loading && <LoadingPanel />}
          <LocalizationProvider language={"tr"}>
            <IntlProvider locale={"tr"}>
              <div style={styles.customToolbar}>
                <div style={styles.titleText}>KURUM TAKVİMİ</div>
                <div style={styles.monthControls}>
                  <div style={styles.monthTitle}>
                    {getMonthName()}
                  </div>
                  <div style={styles.buttonGroup}>
                    <button
                      onClick={handlePrevMonth}
                      style={styles.navButton}
                      title="Önceki ay"
                    >
                      ‹
                    </button>
                    <button
                      onClick={handleNextMonth}
                      style={styles.navButton}
                      title="Sonraki ay"
                    >
                      ›
                    </button>
                  </div>
                </div>
              </div>
              {/* ✅ Scheduler container - scroll ve flex layout */}
              <div className="company-calendar" style={styles.schedulerContainer}>
                <style>{`
          .k-scheduler {
            height: 100% !important;
          }
          .k-scheduler .k-toolbar {
            display: none !important;
          }
          .k-scheduler .k-scheduler-footer {
            display: none !important;
          }
            .k-scheduler .k-scheduler-content {
            overflow: hidden !important;
          }
          .k-scheduler .k-scheduler-layout {
            overflow: hidden !important;
          }
          .k-scheduler .k-event {
            cursor: default !important;
          }
        `}</style>
                <Scheduler
                  data={data}
                  item={CustomItem}
                  date={currentDate}
                  viewSlot={CustomViewSlot}
                  viewItem={CustomViewItem}
                >
                  <MonthView itemsPerSlot={16} />
                </Scheduler>
              </div>
            </IntlProvider>
          </LocalizationProvider>
        </CardBody>
      </Card>
    </div>
  );
}

const styles = {
  // ✅ Wrapper - flex layout ve scroll
  wrapper: {
    display: "flex",
    width: "100%",
    minHeight: "100vh",
    overflow: "auto", // ✅ Wrapper scroll yapabilir
  },
  // ✅ Card - tam genişlik
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    margin: 0,
    borderRadius: 0,
  },
  // ✅ CardBody - flex layout
  cardBody: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: 0,
    gap: 0,
  },
  // ✅ Scheduler container - auto height ve internal scroll
  schedulerContainer: {
    flex: 1,
    overflow: "auto",
    minHeight: "500px", // ✅ Minimum yükseklik
  },
  customToolbar: {
    padding: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e0e0e0",
    backgroundColor: "#fafafa",
    flexShrink: 0,
    gap: "16px",
  },
  titleText: {
    fontSize: "24px",
    fontWeight: "900",
    color: "#1a252f",
    whiteSpace: "nowrap",
  },
  monthControls: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    flexShrink: 0,
  },
  buttonGroup: {
    display: "flex",
    gap: "10px",
    flexShrink: 0,
  },
  navButton: {
    width: "40px",
    height: "40px",
    border: "2px solid #3498db",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    cursor: "pointer",
    fontSize: "20px",
    fontWeight: "700",
    color: "#3498db",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    flexShrink: 0,
  },
  monthTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#1a252f",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
};

export { CompanySchedulerIntra2 };